import React, { useContext, useEffect } from 'react'
import { PanelStyleContext } from '../../panel/PanelStyleContext'

const InputComparisonOperator = ({
    comparisonOperators,
    comparisonOperatorName,
    register,
    unregister,
    setValue,
    initialComparisonOperatorValues,
    checkForBetweenOperator,
    between,
}) => {
    const { selectDropDownCaratClass } = useContext(PanelStyleContext)

    useEffect(() => {
        if (between) {
            try { unregister(comparisonOperatorName) } catch {}
            setValue(`${comparisonOperatorName}[0]`, '>=')
            setValue(`${comparisonOperatorName}[1]`, '<=')
        } else {
            try { unregister(`${comparisonOperatorName}[0]`) } catch {}
            try { unregister(`${comparisonOperatorName}[1]`) } catch {}
        }
    }, [between])

    if (between) {
        return (
            comparisonOperators && (
                <div
                    className={`control formComparisonWidthLimiter ${selectDropDownCaratClass}`}
                >
                    <div className="select is-small formComparisonOperatorWrapper">
                        <select
                            onChange={checkForBetweenOperator}
                            className="formSelect"
                            defaultValue={'BETWEEN'}
                            value={'BETWEEN'}
                        >
                            {comparisonOperators.map((operator, idx) => (
                                <option value={operator} key={`option-${idx}`}>
                                    {operator.toUpperCase()}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="is-hidden">
                        <select
                            defaultValue={'>='}
                            {...register(`${comparisonOperatorName}[0]`)}
                        >
                            <option value={'>='}>{`>=`}</option>
                        </select>
                        <select
                            defaultValue={'<='}
                            {...register(`${comparisonOperatorName}[1]`)}
                        >
                            <option value={'<='}>{`<=`}</option>
                        </select>
                    </div>
                </div>
            )
        )
    } else {
        const { onChange: registerOnChange, ...registerRest } = register(comparisonOperatorName)
        return (
            comparisonOperators && (
                <div
                    className={`control formComparisonWidthLimiter ${selectDropDownCaratClass}`}
                >
                    <div className="select is-small formComparisonOperatorWrapper">
                        <select
                            onChange={(e) => {
                                checkForBetweenOperator(e)
                                registerOnChange(e)
                            }}
                            className="formSelect"
                            {...registerRest}
                            defaultValue={initialComparisonOperatorValues[0]}
                        >
                            {comparisonOperators.map((operator, idx) => (
                                <option value={operator} key={`option-${idx}`}>
                                    {operator.toUpperCase()}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
            )
        )
    }
}

export default InputComparisonOperator
